import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const initialState = {
  messages: [],
  stats: null,
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: '',
};

// Get axios config with token
const getConfig = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

// Send message
export const sendMessage = createAsyncThunk(
  'messages/send',
  async ({ messageData, token }, thunkAPI) => {
    try {
      const response = await axios.post(
        `${API_URL}/whatsapp/send`,
        messageData,
        getConfig(token)
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get message logs
export const getMessageLogs = createAsyncThunk(
  'messages/getLogs',
  async ({ params, token }, thunkAPI) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axios.get(
        `${API_URL}/whatsapp/logs?${queryString}`,
        getConfig(token)
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get message stats
export const getMessageStats = createAsyncThunk(
  'messages/getStats',
  async (token, thunkAPI) => {
    try {
      const response = await axios.get(
        `${API_URL}/whatsapp/stats`,
        getConfig(token)
      );
      return response.data.data;
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const messageSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = '';
    },
  },
  extraReducers: (builder) => {
    builder
      // Send message
      .addCase(sendMessage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Get logs
      .addCase(getMessageLogs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMessageLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.messages = action.payload.data;
      })
      .addCase(getMessageLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Get stats
      .addCase(getMessageStats.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMessageStats.fulfilled, (state, action) => {
        state.isLoading = false;
        state.stats = action.payload;
      })
      .addCase(getMessageStats.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = messageSlice.actions;
export default messageSlice.reducer;
